<script>
import FormItemInputMultiple from '@components/form-item-input-multiple.vue'
export default {
  page: {
    title: 'Form Components',
  },
  components: {
    FormItemInputMultiple,
  },
  data() {
    return {
      sodaFlavor: '',
      soupFlavor: '',
      toppings: [],
      names: [],
      comments: [],
      musicStylesObject: [
        {
          id: 1,
          label: 'Bossa Nova',
        },
        {
          id: 2,
          label: 'Jazz',
        },
        {
          id: 3,
          label: 'Pop',
        },
        {
          id: 4,
          label: 'Heavy Metal',
        },
        {
          id: 5,
          label: 'Classical',
        },
      ],
      selectedMusicObjects: [],
    }
  },
  methods: {},
}
</script>

<template>
  <div>
    <div class="col my-3">
      <h1>Form Components</h1>
    </div>
    <div class="col">
      <h2 class="my-3">Input Multiple</h2>
      <h4>Current comments are: {{ comments }}</h4>
      <FormItemInputMultiple v-model="comments" :placeholder="'Add keyword'"></FormItemInputMultiple>
    </div>
    <div class="col">
      <h2 class="my-3">Checkboxes</h2>
      <h4>Current toppings are: {{ toppings }}</h4>
      <BaseCheckbox v-model="toppings" label="Pepperoni" input-value="pepperoni" />
      <BaseCheckbox v-model="toppings" label="Garlic" input-value="garlic" />
      <BaseCheckbox v-model="toppings" label="Cheese" input-value="cheese" />
      <BaseCheckbox v-model="toppings" label="Oregano" input-value="oregano" />
      <br />
      <h4>Current names are: {{ names }}</h4>
      <BaseCheckbox v-model="names" label="John" input-value="John" />
      <BaseCheckbox v-model="names" label="Rey" input-value="Rey" />
      <BaseCheckbox v-model="names" label="Donald" input-value="Donald" />
      <BaseCheckbox v-model="names" label="Julie" input-value="Julie" />
    </div>
    <div class="col mb-5">
      <h2 class="my-3">Multiselect</h2>
      <h4>Current Music Object is: {{ selectedMusicObjects }}</h4>
      <BaseMultiSelect
        v-model="selectedMusicObjects"
        :options="musicStylesObject"
        :option-text="'label'"
        :placeholder="'Select...'"></BaseMultiSelect>
    </div>
    <div class="col">
      <h2 class="my-3">Radio Button</h2>
      <h4>Current Soda Flavor is: {{ sodaFlavor }}</h4>
      <div style="width: 200px">
        <BaseRadioButton v-model="sodaFlavor" label="Orange" name="sodaFlavorButton" value="orange" />
        <BaseRadioButton v-model="sodaFlavor" label="Grape" name="sodaFlavorButton" value="grape" />
      </div>
      <br />
      <h4>Current Soup Flavor is: {{ soupFlavor }}</h4>
      <div style="width: 400px">
        <BaseRadioButton v-model="soupFlavor" label="Tomato" name="soupFlavorButton" value="tomato" />
        <BaseRadioButton v-model="soupFlavor" label="Pumpkin" name="soupFlavorButton" value="pumpkin" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
